<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <p v-if="loading" class="text-muted">
        <i class="fa fa-spinner fa-spin"></i> {{ _('Loading...') }}
      </p>
      <p v-else-if="!items.length" class="text-muted">{{ emptyText }}</p>
      <div v-else style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
        <table class="table table-striped table-condensed" style="margin-bottom: 0">
          <thead>
            <tr>
              <th style="width: 40px">
                <input type="checkbox" :checked="allSelected" v-on:change="toggleAll" />
              </th>
              <th style="width: 70px">{{ _('ID') }}</th>
              <th>{{ _('Name') }}</th>
              <th style="width: 140px">{{ _('Type') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id" style="cursor: pointer" v-on:click="toggleItem(item.id)">
              <td v-on:click.stop>
                <input type="checkbox" :value="item.id" v-model="selectedIds" />
              </td>
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="restore" :disabled="!canRestore">
        <i :class="'fa fa-fw fa-' + (restoring ? 'spinner fa-spin' : 'undo')"></i> {{ _('Restore') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import errors from '~/lib/errors'

export default {
  mixins: [errors],
  props: {
    baseDomain: { type: String, required: true },
    shopId: { type: String, required: true },
    apiKey: { type: String, required: true },
    targetShopId: { type: String, required: true },
    kind: { type: String, required: true } // 'product' | 'resource'
  },
  data () {
    return {
      items: [],
      selectedIds: [],
      loading: false,
      restoring: false
    }
  },
  computed: {
    isProduct () {
      return this.kind === 'product'
    },
    title () {
      return this.isProduct ? this._('Deleted products') : this._('Deleted resources')
    },
    emptyText () {
      return this.isProduct ? this._('No deleted products.') : this._('No deleted resources.')
    },
    listParam () {
      return this.isProduct ? 'deletedProducts=1' : 'deletedResources=1'
    },
    restoreOperation () {
      return this.isProduct ? 'restoreProducts' : 'restoreResources'
    },
    allSelected () {
      return this.items.length > 0 && this.selectedIds.length === this.items.length
    },
    someSelected () {
      return this.selectedIds.length > 0
    },
    canRestore () {
      return this.someSelected && !this.restoring && !this.loading
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggleItem (id) {
      const index = this.selectedIds.indexOf(id)
      if (index === -1) {
        this.selectedIds.push(id)
      } else {
        this.selectedIds.splice(index, 1)
      }
    },
    toggleAll (event) {
      if (event.target.checked) {
        this.selectedIds = this.items.map(item => item.id)
      } else {
        this.selectedIds = []
      }
    },
    async loadItems () {
      this.loading = true
      this.selectedIds = []
      try {
        const response = await axios.get(
          this.baseDomain + this.shopId + '/admin/shops/' + this.targetShopId + '.json?apikey=' + this.apiKey + '&' + this.listParam
        )
        const rows = Array.isArray(response.data) ? response.data : []
        this.items = rows.map(item => ({
          id: parseInt(item.id, 10),
          name: item.name,
          type: item.type
        }))
      } catch (e) {
        this.items = []
        this.showError(e)
      }
      this.loading = false
    },
    async restore () {
      if (!this.canRestore) {
        return
      }
      this.restoring = true
      try {
        await axios.patch(
          this.baseDomain + this.shopId + '/admin/shops/' + this.targetShopId + '.json?apikey=' + this.apiKey,
          {
            operation: this.restoreOperation,
            shops: [this.targetShopId],
            ids: this.selectedIds
          }
        )
        this.showNotification(this._('Restored successfully!'))
        await this.loadItems()
      } catch (e) {
        this.showError(e)
      }
      this.restoring = false
    }
  },
  created () {
    this.loadItems()
  }
}
</script>
